var ToutThree = (function () {
  

  // context argument added to allow function to be called with a scope on touts loaded asynchronously inside modals
  function init(context) {
    // only tier 3 touts are not children of an article.rzf-gry-tout
    var $tierThreeTouts = $('.rzf-gry-multi-column-container', context).find('.rzf-gry-tout-tile').parent(':not(.rzf-gry-tout)');

    $tierThreeTouts.each(function () {
      $(this).closest('.rzf-gry-multi-column-container').addClass('rzf-gry-tout-tier-3');
    });
  }

  return {
    init: init,
  };
}());
